import Layout from '@components/Layout';
import Table, { IColumnTable } from '@components/table-devextreme/Table';
import Checkbox from 'antd/lib/checkbox';
import { RootState } from 'app/store';
import Helpers from 'helpers/Helpers';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import TableTitle from '@components/table-devextreme/TableTitle';

import { useThongKeSim } from 'apis/queries';
import { updatePageLoadingApi, updateSelectDateTime } from '@slice/select.slice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { Button, Form, Input, message, Space } from 'antd';
import UtilOrder, { convertTime } from '@pages/OrganizedSales/CreateOrders/utilOrder';
import { IOrderReport } from '@models/OrderManager';
import { KEY_ENTER, MINPAGESIZE3 } from 'global/Global';
import moment from 'moment';
import RangeDateJs from '@components/rangeDateTimeJs';
import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import OrderManagerApi from 'apis/api/OrderManager';

export default function ReportBySim() {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [form] = Form.useForm();
  const timeSelected = useSelector((state: RootState) => state.select.selectedTime);
  const [showInfoCus, setShowInfoCus] = useState<boolean>(false);

  const [searchText, setSearchText] = useState<string | null>('');
  const [checkedSixMonth, setCheckedSixMonth] = useState<boolean>(false);
  const [isShowPercentLoading, setIsShowPercentLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>([]);
  const [percent, setPercent] = useState<number>(0);
  const refControlData = useRef<any>(0);
  const percentLoading = useRef<number>(0);
  const refLoadingData = useRef<any>(false);
  const limit = 4;

  const onLoadDetailAllOrder = async (data: any[]) => {
    const tempData: any[] = [];
    dispatch(updatePageLoadingApi(true));

    for (let i = 0; i < data.length; i++) {
      const object = {
        ...data[i],
        // countOrder: 0,
        index: i + 1,
        ngayXuat: data[i].ngayXuat?.startsWith('0001-01-01') ? '' : new Date(data[i].ngayXuat)
      };
      tempData[i] = { ...object };
    }
    dispatch(updatePageLoadingApi(false));
    if (tempData.length > 0) {
      setTableData([...tempData].sort((a, b) => new Date(b.ngayXuat).getTime() - new Date(a.ngayXuat).getTime()));
    } else {
      setTableData([]);
    }
  };

  const fetchRangeData = async ({ startDate, endDate, step, type, phone }) => {
    const datesArr = Helpers.EnumerateDaysBetweenDates(startDate, endDate, timeSelected, step);
    const totalApi = datesArr.length - 1;
    let loaded = 0;
    setIsShowPercentLoading(true);
    percentLoading.current = 0;
    const stack = [];
    refLoadingData.current = true;

    for (let i = 0; i < totalApi; i++) {
      const dataBody = {
        from: datesArr[i],
        to: datesArr[i + 1],
        type,
        phoneNumber: phone
      };

      try {
        dispatch(updatePageLoadingApi(true));
        const res = await OrderManagerApi.ThonekeSim(dataBody);
        if (!res.data.error) {
          const list = res.data.data.map(item => ({ ...item }));
          stack.push(list);
        }

        // update loading %
        loaded++;
        percentLoading.current = (loaded / totalApi) * 100;
        setPercent(percentLoading.current);

        const flatten = stack.flat();

        await Helpers.DelayTime(250);

        const rounded = Number(percentLoading.current.toFixed(0));
        // if (rounded < 5 || rounded % 10 === 0) {
        //   // setTableData(flatten);
        //   onLoadDetailAllOrder(flatten);
        // }
        dispatch(updatePageLoadingApi(false));
      } catch (e) {
        console.log('error req', e);
        dispatch(updatePageLoadingApi(false));
      }
    }

    // Final update
    percentLoading.current = 100;
    setPercent(100);

    const finalData = stack.flat().sort((a, b) => new Date(b.ngayXuat).getTime() - new Date(a.ngayXuat).getTime());
    // setTableData(finalData);

    const tempData: any[] = [];

    for (let i = 0; i < finalData.length; i++) {
      const object = {
        ...finalData[i],
        // countOrder: 0,
        index: i + 1,
        ngayXuat: finalData[i].ngayXuat?.startsWith('0001-01-01') ? '' : new Date(finalData[i].ngayXuat)
      };
      tempData[i] = { ...object };
    }

    setTimeout(() => {
      setIsShowPercentLoading(false);
    }, 500);
    dispatch(updatePageLoadingApi(false));
    if (tempData.length > 0) {
      console.log('tempDataV2', { tempData });
      setTableData([...tempData]);
    } else {
      setTableData([]);
    }

    refControlData.current = finalData.length;
    refLoadingData.current = false;
    dispatch(updatePageLoadingApi(false));
    return finalData;
  };

  // eslint-disable-next-line
  const handleView = async () => {
    setTableData([]);
    refControlData.current = 0;

    const startDate = moment(timeSelected.beginTime);
    const endDate = moment(timeSelected.endTime);
    const numDay = moment.duration(endDate.diff(startDate)).asMinutes() / 1440;

    // nếu nhỏ hơn limit thì gọi hàm search như cũ
    if (numDay <= limit) {
      return handleSearchSim();
    }
    if (checkedSixMonth) {
      return handleSearchSim();
    } else {
      const type = 1;
      const phone = Helpers.TrimSearch(searchText) || '';

      await fetchRangeData({
        startDate,
        endDate,
        step: 60, // tách API mỗi 60 ngày
        type,
        phone
      });
    }
  };

  useEffect(() => {
    handleView();
  }, []);

  const columns: IColumnTable[] = useMemo(() => {
    return [
      {
        dataField: 'index',
        caption: 'Table.STT',
        width: 50,
        alignment: 'right',
        editable: true,
        allowSorting: false
        // fixed: true
      },
      {
        dataField: 'phoneNumber',
        allowSorting: false,
        caption: t('OrganizedSales.OrderManager.AllOrder.Phone')
      },
      {
        dataField: 'maSanPham',
        caption: t('OrganizedSales.OrderManager.AllOrder.CodeProduct')
      },

      {
        dataField: 'tenSanPham',
        allowSorting: false,
        caption: t('OrganizedSales.OrderManager.AllOrder.NameProduct')
      },

      {
        dataField: 'ngayXuat',
        caption: t('OrganizedSales.OrderManager.AllOrder.NgayXuat'),
        format: 'dd/MM/yyyy HH:mm:ss '
      },
      {
        dataField: 'maKhachHang',
        allowSorting: false,
        caption: t('OrganizedSales.OrderManager.AllOrder.CustomerCode'),
        alignment: 'left'
      },
      {
        dataField: 'customerName',
        allowSorting: false,
        caption: t('OrganizedSales.OrderManager.AllOrder.Customer'),
        alignment: 'left',
        minWidth: 220
        // fixed: true
      }
    ];
  }, []);

  const reloadPage = () => {
    dispatch(updatePageLoadingApi(true));
    handleView();
    setTimeout(() => {
      dispatch(updatePageLoadingApi(false));
    }, 500);
  };

  const onRowPreparedStyle = (e: any) => {
    if (e.rowType !== 'data') return;
    if (e.data.isParent) {
      e.rowElement.style.background = '#f4f4f4';
      return e;
    }
  };

  const handleSearchSim = async () => {
    const phone = Helpers.TrimSearch(searchText);
    const type = checkedSixMonth ? 2 : 1;
    const dataBody = {
      from: timeSelected.beginTime || convertTime.begin,
      to: timeSelected.endTime || convertTime.end,
      type,
      phoneNumber: phone
    };

    try {
      dispatch(updatePageLoadingApi(true));
      const res = await OrderManagerApi.ThonekeSim(dataBody);
      dispatch(updatePageLoadingApi(false));

      if (!res.data.error && res.data.data.length > 0) {
        onLoadDetailAllOrder(res.data.data);
        return;
      }

      setTableData([]);

      if (res.data.message === 'timeout') {
        return message.error('Thời gian gửi yêu cầu đã vượt quá giới hạn.');
      }
      message.error('Không tìm thấy dữ liệu nào!');
    } catch (e) {
      dispatch(updatePageLoadingApi(false));
      message.error('Xảy ra lỗi khi tìm sim!');
    }
  };

  const handleKeyDownSearch = event => {
    // if (event.keyCode === KEY_ENTER) {
    //   handleSearchSim(refShiftKey.current);
    // }
    // refShiftKey.current = event.keyCode === KEY_SHIFT;
    // console.log('text search', event, event.keyCode === KEY_SHIFT, event.keyCode === KEY_ENTER);
  };

  const onChangeTextSearch = (event: any) => {
    setSearchText(event.target.value);
  };

  const onSelectDateSearch = useCallback((value: any, stringValue?: string[], isTrueFormat?: boolean) => {
    if (stringValue) {
      const timeFormat = isTrueFormat ? value : Helpers.FormatTimeToISOStringSave(value);
      console.log(
        'range time save',

        value[0],
        value[1],
        timeFormat[0],
        timeFormat[1]
      );

      dispatch(
        updateSelectDateTime({
          beginTime: timeFormat[0],
          endTime: timeFormat[1]
        })
      );
    }
    // gọi api lên server get orderlist by range date
  }, []);

  const headerPage = useMemo(() => {
    const handleFinish = () => {
      handleView();
    };

    return (
      <div className="flex flex-row justify-between flex-wrap items-end">
        <Form form={form} layout="horizontal" onFinish={handleFinish} className="flex flex-wrap items-end space-x-2">
          {/* Checkbox 6 tháng gần nhất */}
          <div className="flex flex-col">
            <span className="text-xs font-semibold flex !flex-col invisible">Tìm theo thời gian tạo</span>
            <Form.Item className="!mb-0" style={{ marginBottom: 0 }}>
              <div className="flex items-center space-x-2">
                <span>Tìm trong 6 tháng gần nhất</span>
                <Checkbox checked={checkedSixMonth} onChange={e => setCheckedSixMonth(e.target.checked)} />
              </div>
            </Form.Item>
          </div>

          {/* Input Sim */}
          <div className="flex flex-col relative">
            <span className="text-xs font-semibold flex !flex-col">Tìm theo sim</span>
            <Form.Item
              name="simNumber"
              className="form-item-fixed"
              rules={[
                {
                  required: checkedSixMonth,
                  message: 'Vui lòng nhập số sim'
                }
              ]}
              validateTrigger="onSubmit"
            >
              <Input
                style={{ width: 250, borderRadius: 4 }}
                placeholder="Nhập số sim"
                value={searchText}
                onKeyDown={handleKeyDownSearch}
                onChange={onChangeTextSearch}
              />
            </Form.Item>
          </div>

          {/* RangeDateJs */}
          <div className="flex flex-col">
            <span className="text-xs font-semibold flex !flex-col invisible">Tìm theo thời gian tạo</span>
            <Form.Item className="!mb-0" style={{ marginBottom: 0 }}>
              <RangeDateJs
                widthBox={265}
                limitTimeRange={184}
                checkType="sim"
                onSelectDateChange={(date, stringDate) => onSelectDateSearch(date, stringDate)}
                disabled={checkedSixMonth}
              />
            </Form.Item>
          </div>

          {/* Button */}
          <div className="flex flex-col">
            <span className="text-xs font-semibold flex !flex-col invisible">Tìm theo thời gian tạo</span>
            <Form.Item className="!mb-0" style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit" className="min-w-[80px]">
                Xem
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    );
  }, [checkedSixMonth, form, handleView, onSelectDateSearch, searchText]);

  const renderTable = useMemo(() => {
    return (
      <Table
        tableName={t('Report.ReportBySim.Title')}
        tableId="baocaotheonvkt"
        keyExpr="maDonHang"
        columns={columns}
        data={tableData}
        fileNameExport={t('Report.ReportBySim.Title')}
        onRowPreparedStyle={onRowPreparedStyle}
        isStriped={false}
        oncClickReload={() => {
          reloadPage();
        }}
        reload={true}
        hiddenAddButton={true}
        downHeight={11.8}
        minPageSize={MINPAGESIZE3}
        allowExcel={true}
        customCenterToolbar={() => <TableTitle title={t('Report.ReportBySim.Title')} />}
      />
    );
  }, [columns, tableData, t]);
  return (
    <Layout path={[{ name: 'Báo cáo thống kê sim' }]}>
      <div className="relative">
        <div className="flex">{headerPage}</div>
        {/* {renderTable} */}

        <div className="px-1 pt-1 relative">
          {isShowPercentLoading && (
            <span className="text-[13.5px] rounded italic px-1 font-semibold text-yellow-300 bg-red-600 absolute top-[-26px] right-1 z-20">
              {percentLoading.current > 0 &&
                t('Report.ReportBySim.Notice.LoadingStatus') + ' ' + percentLoading.current.toFixed(0) + '%'}
            </span>
          )}
          {renderTable}
        </div>
      </div>
    </Layout>
  );
}
